/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/** 客户端navbar 容器 相关bridge 方法 统一收口 */
import { callNative } from '@/shared/utils/bridge';
import isSupportNativeContainer from '@/shared/utils/isSupportNativeContainer';
import { getTabIdByPath } from '@/shared/utils/getTabIdByPath/getTabIdByPath';
import isShowContainerPath from '@/shared/utils/isShowContainerPath';
import { UserCreditType } from '../homeV2Status/types';
import { taskQueueManager } from './taskQueueManager';


/** TODO: 方法进一步抽离，应对后续单tab容器场景 */
/** 是否在原生容器中 tabbar模式 */
export const skNativeContainer = async (
): Promise<boolean> => {
  if (isSupportNativeContainer()) {
    try {
      const data: {
        isNativeContainer: boolean,
        /** 目前只有一个 zyqHome */
        containerRoute: string,
      } = await callNative({
        classMap: 'business/finance_tabbar',
        method: 'skNativeContainer',
      });

      const { isNativeContainer, containerRoute } = data;
      /** containerRoute === 'zyqHomeTest' 调试代码 */
      const isContainer = isNativeContainer && (containerRoute === 'zyqHome' || containerRoute === 'zyqHomeTest');
      return Promise.resolve(isContainer);
    } catch (error) {
      return Promise.resolve(false);
    }
  }
  return Promise.resolve(false);
};

/**
 * 采用skNativeContainer获取路由来判断是否在容器化入口中
 * @returns 是否在容器化入口中
 */
export const skNativeContainerOpen = async (
): Promise<boolean> => {
  if (isSupportNativeContainer()) {
    try {
      const data: {
        isNativeContainer: boolean,
        /** 目前只有一个 zyqHome */
        containerRoute: string,
      } = await callNative({
        classMap: 'business/finance_tabbar',
        method: 'skNativeContainer',
      });

      const { containerRoute } = data;
      return Promise.resolve(containerRoute === 'zyqHome'
        || containerRoute === 'zyqHomeTest');
    } catch (error) {
      return Promise.resolve(false);
    }
  }
  return Promise.resolve(false);
};


/** 当前tabbar是否处于显示状态, 表示bridge响应时当下的tabbar显示 隐藏 状态 */
export const getTabbarShowStatus = async (
): Promise<boolean> => {
  if (isSupportNativeContainer()) {
    try {
      const data: {
        isTabbarShow: boolean,
      } = await callNative({
        classMap: 'business/finance_tabbar',
        method: 'skNativeContainer',
      });

      const { isTabbarShow } = data;
      return isTabbarShow;
    } catch (error) {
      return false;
    }
  }
  return false;
};

/** 显示、隐藏 tabbar，弹窗 从下往上的 popup 、路由跳转离开首页时，需要调用隐藏，回到首页时 显示 */
export const changeTabbarShowStatus = async (show: boolean,
  options?: {
  delay?: number,
  shouldShowCallback?: () => boolean,
  },
): Promise<void> => {
  const { delay, shouldShowCallback } = options || {};
  if (isSupportNativeContainer()) {
    if (await skNativeContainer()) {
      // 将任务添加到队列中
      taskQueueManager.addTask('skChangeTabbarShowStatus', {
        delay,
        execute: async () => {
          try {
            // 当show为true时，如果回调函数不为空且返回false，则不显示tabbar
            if (show && shouldShowCallback && shouldShowCallback() !== true) return;

            await callNative({
              classMap: 'business/finance_tabbar',
              method: 'skChangeTabbarShowStatus',
              params: {
                show,
                tabId: getTabIdByPath(),
              },
            });
          } catch (error) {
            // Error handled silently
          }
        },
      });
    } else {
      return Promise.resolve();
    }
  }
  return Promise.resolve();
};

/** 给tabbar 加遮罩阴影，针对首页的弹窗场景 */
export const changeTabbarMaskStatus = async (params: {
  /** 是否显示（必填） */
  show: boolean,
  /** 动画时长，单位为ms（选填，默认值为300ms） */
  duration?: number,
  /** 显示时的透明度（选填，默认值为0.7） */
  opacity?: number,
  /** 动画类型，枚举：easeInOut-开始/结束慢 中间快，easeIn-开始慢结束快，easeOut-开始快结束慢，linear-匀速（选填，默认值为linear匀速） */
  type?: string,
  // ** tabId */
  tabId?: string,
  /** 任务延时，单位为ms（选填，默认值为0ms） */
  delay?: number,
  /** 判断是否需要显示遮罩的回调 */
  shouldShowCallback?: () => boolean,
}): Promise<void> => {
  if (isSupportNativeContainer()) {
    if (await skNativeContainer()) {
      // 将任务添加到队列中
      taskQueueManager.addTask('skChangeTabbarMaskStatus', {
        delay: params.delay,
        execute: async () => {
          try {
            // 需要显示遮罩，但是回调函数返回false，则不显示遮罩
            if (params.show
              && params.shouldShowCallback
              && params.shouldShowCallback() !== true) return;

            await callNative({
              classMap: 'business/finance_tabbar',
              method: 'skChangeTabbarMaskStatus',
              params: {
                show: params.show,
                duration: params.duration,
                opacity: params.opacity,
                type: params.type,
                tabId: params.tabId,
              },
            });
          } catch (error) {
            // Error handled silently
          }
        },
      });
    } else {
      return Promise.resolve();
    }
  }
  return Promise.resolve();
};

/** 移除native 客户端原生loading页 */
export const removeContainerLoading = async (callback?: () => void): Promise<void> => {
  if (isSupportNativeContainer()) {
    try {
      return callNative({
        classMap: 'business/finance_tabbar',
        method: 'skRemoveContainerLoading',
      });
    } catch (error) {
      // error
    }
  }
  if (callback) {
    callback();
  }
  return Promise.resolve();
};


/** 获取用户登录信息 包含 哈啰平台 和金融 */
export const getSkUserAuth = async (params: {
  /** 是否需要强制刷新：true-忽略缓存，获取最新的金融token；false-优先读取缓存 */
  needRefresh?: boolean
},
): Promise<{
  hello: NativeModel.OriginUserInfo | '',
  sk: NativeModel.FinanceUser | '',
}> => {
  if (isSupportNativeContainer()) {
    if (await skNativeContainer()) {
      try {
        return await callNative({
          classMap: 'business/finance',
          method: 'skUserAuth',
          params,
        });
      } catch (error) {
        return Promise.resolve({
          hello: '',
          sk: '',
        });
      }
    } else {
      return Promise.resolve({
        hello: '',
        sk: '',
      });
    }
  }
  return Promise.resolve({
    hello: '',
    sk: '',
  });
};


/** 获取预请求数据
 * 接口异常时，返回空{}
 */
export const getSkPreRequestData = async (params: {
  /** 项目名称 AppFinanceH5Web AppFinanceLoanH5 AppFinanceMemberH5 */
  project: string,
  /** 接口action  */
  action: string,
},
): Promise<UserCreditType | {}> => {
  if (isSupportNativeContainer()) {
    if (await skNativeContainer()) {
      try {
        return callNative({
          classMap: 'business/finance',
          method: 'skPreRequestData',
          params,
        });
      } catch (error) {
        return Promise.resolve({});
      }
    } else {
      return Promise.resolve({});
    }
  }
  return Promise.resolve({});
};


/**
 * 获取tabbar信息
 */
export const getSkTabbarInfo = async (): Promise<[{
  /** tab的唯一id */
  tabId?: string,
}]> => {
  if (isSupportNativeContainer()) {
    if (await skNativeContainer()) {
      try {
        return callNative({
          classMap: 'business/finance_tabbar',
          method: 'skTabbarInfo',
        });
      } catch (error) {
        return Promise.resolve([{}]);
      }
    } else {
      return Promise.resolve([{}]);
    }
  }
  return Promise.resolve([{}]);
};

/**
 * 回到指定tab 一级页面
 */
export const skToTabbarPage = async (
  params: {
    /** 'home/member/my' */
    tabId: string,
  },
): Promise<void> => {
  if (isSupportNativeContainer()) {
    /** TODO: 暂时注释掉，因为skNativeContainer() 判断加上以后 会影响后面逻辑执行 */
    // if (await skNativeContainer()) {
    try {
      return callNative({
        classMap: 'business/finance_tabbar',
        method: 'skToTabbarPage',
        params,
      });
    } catch (error) {
      return Promise.resolve();
    }
    // } else {
    //   return Promise.resolve();
    // }
  }
  return Promise.resolve();
};


/** 清空金融用户token缓存 */
export const skClearUserCache = async (
): Promise<void> => {
  if (isSupportNativeContainer()) {
    if (await skNativeContainer()) {
      try {
        return callNative({
          classMap: 'business/finance',
          method: 'skClearUserCache',
        });
      } catch (error) {
        return Promise.resolve();
      }
    } else {
      return Promise.resolve();
    }
  }
  return Promise.resolve();
};


interface tabBarInfoType {
  /** tab的唯一id home member my */
  tabId?: string,
  link?: string,
  title?: string,
  haveShown?: boolean
}
/**
 * 获取tabbar信息
 */
export const getSkTabInfo = async (tabId: string): Promise<tabBarInfoType> => {
  if (isSupportNativeContainer()) {
    if (await skNativeContainer()) {
      try {
        return await callNative({
          classMap: 'business/finance_tabbar',
          method: 'skTabInfo',
          params: {
            tabId,
          },
        });
      } catch (error) {
        return Promise.resolve({
          haveShown: true,
        });
      }
    } else {
      return Promise.resolve({
        haveShown: true,
      });
    }
  }
  return Promise.resolve({
    haveShown: true,
  });
};

/**
 * 获取tabbar信息
 */
export const getCurrentSkTabbarInfo = async (): Promise<{
  /** tab的唯一id */
  tabId?: string,
}> => {
  if (isSupportNativeContainer()) {
    if (await skNativeContainer()) {
      try {
        return callNative({
          classMap: 'business/finance_tabbar',
          method: 'skCurrentTabInfo',
        });
      } catch (error) {
        return Promise.resolve({});
      }
    } else {
      return Promise.resolve({});
    }
  }
  return Promise.resolve({});
};
